
import { RoadRage } from '../../RoadRage';
import { GameData } from "../../server/data/BaseModel";

import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { APIEvent } from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

import { SoundConfig } from "../../config/sound/SoundConfig";
import { SoundManager } from "../../config/sound/SoundManager";

import { StopPresentation } from "../../presentations/general/StopPresentation";

import { RoadRageEngineManager } from "../../reel/RoadRageEngineManager";
import { RoadRageEngineController } from "../../reel/RoadRageEngineController";
import { CarMoveInfo, CarTypes } from '../../server/data/GameDataModels';
import { RoadRageReelOverlay } from '../../reel/RoadRageReelOverlay';
import { Background } from '../../background/Background';
import { PosterManager, FeaturePosterState } from '../../independent/poster/PosterManager';

export class NormalStopPresentation extends StopPresentation {

    private scatterAttentionStart: number = -1;

    private deadSpin: boolean = false;

    private featureBuy: boolean = false;

    private playFeatureBuy: boolean = false;
    private playedFeature: boolean = false;

    private attentionSoundStarted: boolean = false;
    private featuerBuyCheckType: string = "LUCKY_DRAW";

    protected carInfos: CarMoveInfo[];

    constructor() {
        super();
        this.featureBuyEventCallback();
    }

    private featureBuyEventCallback(): void {
        SlotGame.apiPlugin.events.on(APIEvent.BET, (v: any) => {
            this.featureBuy = !!v.playerInteraction;
            this.playFeatureBuy = this.featureBuy && v.playerInteraction.featureName === this.featuerBuyCheckType;
            this.playedFeature = false;
        });
    }

    setGamedData(data: GameData): void {
        super.setGamedData(data);

        this.attentionSoundStarted = false;

        this.carInfos = data.Reel.carMoveInfo.filter(c => c.type === CarTypes.YELLOW);
        let countTempScatter = 0;
        this.scatterAttentionStart = -1;

        RoadRageEngineManager.RAll(r => {
            if (countTempScatter == 2) return;
            if (this.scatterPos[r.reelID] >= 0) countTempScatter++;
            if (countTempScatter == 2) this.scatterAttentionStart = r.reelID;
        })

        // this.deadSpin = this.gameData.Reel.nearWinMap.length <= 2
        if (this.featureBuy || !this.gameData.isNormalMode) this.scatterAttentionStart = -1;
    }

    preStart(): void {
        super.preStart();
        // SoundManager.setDeadSpinVolume(this.deadSpin);
    }

    public createPresentation(enableSkip: Function) {
        enableSkip(!RoadRageEngineManager.isQuickStop);

        if (this.playFeatureBuy) {
            if (RoadRageEngineManager.isQuickStop && this.playedFeature) {
                PosterManager.instance.stop(0.01);
            } else if (!this.playedFeature) {
                this.playedFeature = true;
                PosterManager.instance.play("Random_Intro").add(() => { 
                    PosterManager.instance.stop();
                    RoadRageEngineManager.getReel(0).attention(true) });
            }
        }

        if (this.readyToDefineStop()) {

            this.createStopSpins();

            const delay: number[] = this.defineDelays();

            RoadRageEngineManager.stopReels(delay);
        }
    }

    createStopSpins(): void {
        RoadRageEngineManager.RAll((rc: RoadRageEngineController) => rc.createStop({
            stops: () => this.onStops(rc),
            bounce: () => this.onBounce(rc),
            stopped: () => this.onStopped(rc)
        }, this.scatterAttentionStart > 0 && rc.reelID > this.scatterAttentionStart && !RoadRageEngineManager.isQuickStop));
    }

    defineDelays(): number[] {

        const delay: number[] = this.basicStopDelay;

        if (this.featureBuy)
            this.featureBuyDelay(delay);
        else {
            if (this.scatterDelay(delay)) {
                this.winHitDelay(delay);
            }
        }

        return delay;
    }

    featureBuyDelay(delay: number[]): void {
        if (!this.playFeatureBuy || RoadRageEngineManager.isQuickStop) return;
        let delays: number = 4;
        for (let i: number = 0; i < delay.length; i++) {
            delay[i] += delays;
        }

        delays = 0;
        for (let i: number = 0; i < delay.length; i++) {
            delay[i] += delays;
            delays += 2;
        }
    }

    scatterDelay(delay: number[]): boolean {
        if (RoadRageEngineManager.isQuickStop) return false;

        let delays: number = 0;
        let scatterCount: number = 0;
        for (let i: number = 0; i < delay.length; i++) {
            delay[i] += delays;

            scatterCount += this.scatterPos[i] >= 0 ? 1 : 0;
            delays += scatterCount > 1 ? 2 : scatterCount == 1 ? 0.25 : 0;
        }

        return scatterCount >= 0;
    }


    winHitDelay(delay: number[]): void {
        if (this.possibleWin.length <= 2) return;
        // let delays: number = 0;
        // for (let i: number = 2; i < delay.length; i++) {
        //     delay[i] += delays;

        //     if (this.possibleWinSymbols.length - 1 > i)
        //         delays += 0.1 + i * 0.1;
        //     else {
        //         delays += 0.1 + i * 0.1;
        //         break;
        //     }
        // }
    }

    onStops(rc: RoadRageEngineController): void {
        rc.setGraphAlpha(0, rc.stopDuration);
    }

    onBounce(rc: RoadRageEngineController): void {

        if (this.gameData.Reel.YellowCarPositions[rc.reelID].length) {
            const startPos: number = this.animationTl.time();
            let upgrades:boolean = false;
            rc.AllWindowSymbols.forEach(s => {
                if (!s.isCar) {
                    if(s.splitValue > 1) upgrades = true;
                    this.animationTl.add(s.addMult(1, undefined, true, false), startPos);
                    this.animationTl.add(() => { s.Explosion() }, startPos);
                    this.animationTl.to(this,{duration:0.05})
                }
            });

            this.animationTl.add(() => {
                if (upgrades) {
                    SoundManager.playSoundEffect(SoundConfig.MULT_LAND_UPGRADE)
                } else {
                    SoundManager.playSoundEffect(SoundConfig.MULT_LAND)
                }
            }, startPos + 0.8)
        }

        this.onScatterHits(rc);
        this.onScatterLanding(rc.reelID);
        this.playBounceSound(rc.reelID);

        rc.AllWindowSymbols.forEach(s => {
            s.onBounceEffect(rc.engine.timeLeft);
        });

        if(this.playFeatureBuy){
            rc.attention(false)
            if(rc.reelID + 1 != RoadRageEngineManager.AllReels.length)
                RoadRageEngineManager.getReel(rc.reelID + 1).attention(true);
        }

        this.possibleWinNonWins(rc.reelID);
    }

    onScatterHits(rc: RoadRageEngineController) {
        super.onScatterHits(rc);
    }


    playBounceSound(reelID: number): void {
        SoundManager.playReelStop(reelID, this.attentionSoundStarted);
        if (RoadRageEngineManager.lastStopOrder === reelID) {
            SoundManager.stopSoundEffect(SoundConfig.REELS_SPINNING);
        }
    }

    onStopped(rc: RoadRageEngineController): void {
        RoadRageReelOverlay.instance.setDisabled(this.gameData.Reel.reelsWithScatters[rc.reelID], rc.reelID);
    }

    onScatterLanding(reelID: number) {
        if (this.scatterAttentionStart > 0 && this.scatterAttentionStart <= reelID && !RoadRageEngineManager.isQuickStop) {
            if (reelID != RoadRageEngineManager.AllReels.length - 1) {

                RoadRageEngineManager.getReel(reelID).attention(false);
                RoadRageEngineManager.getReel(reelID + 1).attention(true);

                if (this.scatterAttentionStart === reelID) {
                    SoundManager.playSoundEffect(SoundConfig.SCATTER_ANTICIPATION_NORMAL)
                    SoundManager.fadeOutAmbient(100, 0.2);
                    this.attentionSoundStarted = true;
                }

                if (this.scatterAttentionStart == reelID) {
                    Background.instance.attentionStart();
                    for (let i: number = 0; i <= reelID; i++) {
                        RoadRageEngineManager.getReel(i).AllWindowSymbols.forEach(s => {
                            if (s.isNormalSym) s.markNonWin(true, 0.42, 1.5)
                        });
                    }
                    // RoadRage.background.changeGFXAlpha(0.42,1.5);
                } else {
                    RoadRageEngineManager.getReel(reelID).AllWindowSymbols.forEach(s => {
                        if (s.isNormalSym) s.markNonWin(true, 0.42, 1.5)
                    });
                }
            }
        }
    }

    resetPreWins(): void {
        RoadRageEngineManager.RSAll((r, s) => s.markNonWin(false, 0, 0.25));
        // RoadRage.background.changeGFXAlpha(0, 0.25);
        const startPos: number = this.animationTl.time();
        this.animationTl.to(this, { duration: 0.125 }, startPos);
    }

    skip(): void {
        super.skip();
    }

    done(): void {

        RoadRage.reelManager.applyMask(false);
        RoadRageEngineManager.RAll(r => r.attention(false))
        if (this.gameData.gameModeChanges) this.resetPreWins();

        if (this.attentionSoundStarted) {
            SoundManager.fadeInAmbient(500);
            SoundManager.fadeSound(SoundConfig.SCATTER_ANTICIPATION_NORMAL, 1, 0, 1000)
        }
    }
}